<template>
    <div class="invention-detail">
        <v-form>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        團隊資訊
                    </div>
                </div>
                <div class="form-content">
                    <div class="form-row">
                        <v-text-field
                            v-model="form.team.name"
                            outlined
                            label="團隊名稱"
                            placeholder=""
                            class="form-input"
                            readonly
                            background-color="#F2F2F2"
                        />
                    </div>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        提案
                    </div>
                </div>
                <div class="form-content">
                    <div class="form-row">
                        <v-text-field
                            v-model="form.proposal.name"
                            outlined
                            label="作品名稱"
                            class="form-input"
                            readonly
                            background-color="#F2F2F2"
                        />
                    </div>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        參賽組別
                    </div>
                    <div class="tips">
                        自選1項
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.proposal.level"
                        class="radio-group"
                        readonly
                    >
                        <v-radio
                            value="大專校院組"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    大專校院組<span
                                        class="radio-tips"
                                    >：全國大專院校在學學生，含五專1-5
                                        年級、碩博士班。</span>
                                </div>
                            </template>
                        </v-radio>
                        <v-radio
                            value="高中職組"
                            color="#898989"
                        >
                            <template v-slot:label>
                                <div class="radio-label">
                                    高中職組<span
                                        class="radio-tips"
                                    >：全國高中職在學學生。</span>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        自選主題
                    </div>
                    <div class="tips">
                        自選1項
                    </div>
                </div>
                <div class="form-content">
                    <v-radio-group
                        v-model="form.proposal.main"
                        class="radio-group"
                        readonly
                    >
                        <div class="radio-type">
                            <div class="label">
                                慈善
                            </div>
                            <div class="block">
                                <v-radio
                                    value="慈善 1.以賑災為主，研發備災，賑災所需相關產品。"
                                    color="#898989"
                                >
                                    <template v-slot:label>
                                        <div class="radio-label">
                                            1.以賑災為主，研發備災，賑災所需相關產品。
                                        </div>
                                    </template>
                                </v-radio>
                                <v-radio
                                    value="慈善 2.以人文關懷為主，研發可以改善弱勢或偏鄉地區之民生或日常問題相關產品。"
                                    color="#898989"
                                >
                                    <template v-slot:label>
                                        <div class="radio-label">
                                            2.以人文關懷為主，研發可以改善弱勢或偏鄉地區之民生或日常問題相關產品。
                                        </div>
                                    </template>
                                </v-radio>
                            </div>
                        </div>
                        <div class="type">
                            <div class="label">
                                醫療
                            </div>
                            <div class="block">
                                <v-radio
                                    value="醫療 1.以長照2.0為主，研發可幫助解決銀髮族或失能之身心障礙者的生理健康或日常照護之產品。"
                                    color="#898989"
                                >
                                    <template v-slot:label>
                                        <div class="radio-label">
                                            1.以長照2.0為主，研發可幫助解決銀髮族或失能之身心障礙者的生理健康或日常照護之產品。
                                        </div>
                                    </template>
                                </v-radio>
                                <v-radio
                                    value="醫療 2.研發可以改善醫療職業環境，提升病人安全及居家照者之產品。"
                                    color="#898989"
                                >
                                    <template v-slot:label>
                                        <div class="radio-label">
                                            2.研發可以改善醫療職業環境，提升病人安全及居家照者之產品。
                                        </div>
                                    </template>
                                </v-radio>
                            </div>
                        </div>
                    </v-radio-group>
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        選擇主題
                    </div>
                    <div class="tips">
                        需符合SDGs中至少1項目標
                    </div>
                </div>
                <div class="form-content">
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs1"
                        value="SDGs1"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs2"
                        value="SDGs2"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs3"
                        value="SDGs3"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs4"
                        value="SDGs4"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs5"
                        value="SDGs5"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs6"
                        value="SDGs6"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs7"
                        value="SDGs7"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs8"
                        value="SDGs8"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs9"
                        value="SDGs9"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs10"
                        value="SDGs10"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs11"
                        value="SDGs11"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs12"
                        value="SDGs12"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs13"
                        value="SDGs13"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs14"
                        value="SDGs14"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs15"
                        value="SDGs15"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs16"
                        value="SDGs16"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                    <v-checkbox
                        v-model="form.proposal.subs"
                        label="SDGs17"
                        value="SDGs17"
                        color="#898989"
                        class="checkbox"
                        readonly
                    />
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        計畫書摘要
                    </div>
                </div>
                <div class="form-content">
                    <v-textarea
                        v-model="form.proposal.abstract"
                        rows="10"
                        counter="300"
                        label="計畫摘要"
                        no-resize
                        outlined
                        readonly
                        background-color="#F2F2F2"
                    />
                </div>
            </div>
            <div class="apply-form-block">
                <div class="left-block">
                    <div class="block-title">
                        計畫書
                    </div>
                </div>
                <div class="form-content">
                    <iframe
                        :src="getPDF($static(form.proposal.pdfFile))"
                        width="100%"
                        height="800"
                        frameborder="0"
                    />
                </div>
            </div>
        </v-form>
        <PointsForm
            :id="$route.params.id"
            :type="'invention'"
            @setTotal="setTotal"
            @setDetailPoints="setDetailPoints"
            @setComments="setComments"
            @openDialog="openDialog"
        />
        <PointsDialog
            :id="$route.params.id"
            :type="'invention'"
            :total="total"
            :is-open="isOpen"
            @closeDialog="closeDialog"
            @toApply="toApply"
        />
    </div>
</template>

<script>
import API from '@/api';
import _ from 'lodash';
import { mapMutations } from 'vuex';
import PointsForm from '@/components/PointsForm.vue';
import PointsDialog from '@/components/Dialog/PointsDialog.vue';

export default {
    components: { PointsForm, PointsDialog },
    data() {
        return {
            refersTeamName: '',
            refersRecommendName: '',
            refersOther: '',
            form: {
                team: {
                    name: '',
                    previewImg: '',
                    school: '',
                    refers: [],
                    teachers: [{
                        name: '',
                        title: '',
                        phone: '',
                        email: '',
                    }],
                    members: [{
                        name: '',
                        phone: '',
                        email: '',
                        department: '',
                        grade: '',
                        pdfFile: '',
                    },
                    {
                        name: '',
                        phone: '',
                        email: '',
                        department: '',
                        grade: '',
                        pdfFile: '',
                    }],
                },
                proposal: {
                    name: '',
                    level: '',
                    main: '',
                    subs: [],
                    abstract: '',
                    pdfFile: '',
                },
                status: '',
            },
            isOpen: false,
            total: 0,
            points: {
                conformity: 0,
                original: 0,
                practicality: 0,
                marketability: 0,
                completion: 0,
            },
            comments: '',
        };
    },
    computed: {},
    created() {
        this.getData();
    },
    mounted() {
    },
    methods: {
        ...mapMutations('mNotification', ['handleError']),
        ...mapMutations('mLoading', ['setLoading']),
        async getData() {
            const { id } = this.$route.params;
            try {
                this.setLoading(true);
                const res = await API.InventionApply.PrivateFetchResource(id);
                this.form = res.data;
                this.setLoading(false);
            } catch (e) {
                console.log('error', e);
                this.setLoading(false);
                this.handleError({
                    message: e || '連線異常',
                    color: 'error',
                });
            }
        },
        getPDF(url) {
            return `https://docs.google.com/viewer?url=${url}&embedded=true`;
        },
        memberNameLabel(index) {
            if (index === 0) {
                return '隊長';
            }
            return `隊員${index}`;
        },
        setTotal(value) {
            this.total = value;
        },
        setDetailPoints(array) {
            _.assign(this.points, array);
        },
        setComments(value) {
            this.comments = value;
        },
        openDialog() {
            this.isOpen = true;
        },
        closeDialog() {
            this.isOpen = false;
        },
        toApply() {
            this.$router.push({ name: 'SubmittedRatingInventionApply' });
        },
    },
};
</script>

<style lang="scss">
@import '@/scss/apply.scss';

.invention-detail {
    padding: 50px 40px;
    .member-file {
        flex: 1;
        display: flex;
        align-items: center;
        margin-top: -50px;
    }

    .team-image-block {
        .preview-card {
            width: 300px;
            height: 300px;
        }
    }

    .pdf-file {
        a {
            color: $color-orange;
            font-weight: 700;
            letter-spacing: 0.1em;
            margin-left: 5px;
        }
    }

    .actions {
        justify-content: center;

        .btn:first-child {
            margin-right: 30px;
        }
    }
}
.checkbox-input{
    padding-top: 0 !important;
    margin-top: 0 !important;
    width: 100%;
    flex: unset;
}
.checkbox-input input{
    padding-left: 10px;
}
@media (min-width: 768px) {
    .checkbox-input{
        max-width: 185px !important;
    }
}
</style>
